







































































































import { Component, Vue } from "vue-property-decorator";
import { GeneralService } from "../services/general-service";
import ProgramLevel from "../components/ProgramLevel.vue";
import config from "../services/api-config";
import router from "../router";
import AuthService from "../services/auth-service";

@Component
export default class Winners extends Vue {
  private isPre2Batch = false;

  private winners = [
    [
      { rollnumber: "FSDICOMBM2001605", name: "M Ibrahim" },
      { rollnumber: "LHRICOMBM1933641", name: "Saffa Khalid" },
      { rollnumber: "lhricspm2094539", name: "M Usama Shad" },
      { rollnumber: "RWPFSCMM2006287", name: "Wajeeha Aqdas" },
      { rollnumber: "ttsfscmm2002323", name: "Nabeera Shahid" },
      { rollnumber: "LHCFSCMM2000098", name: "IQRA AJMAL" },
      { rollnumber: "mwlfscmm209109", name: "Mariyam Fatima" },
      { rollnumber: "grwfscmm2003017", name: "Umm e Kulsoom" },
      { rollnumber: "BHKFSCMM2000010", name: "M Usama Javed" }
    ],
    [
      { rollnumber: "GRWFSCEM2096088", name: "Abdul Rehman Tahir" },
      { rollnumber: "GRWFSCMM2093069", name: "Hafiz Burhan  Akhtar" },
      {
        rollnumber: "RRWPICSPM2001393",
        name: "M. Zakariyya Hashmi"
      },
      { rollnumber: "JPJFSCEM2000078", name: "Zaka Ahmed" },
      { rollnumber: "LHRFSCEM2073895", name: "Ahmad Arshad" },
      { rollnumber: "Psrscmm2000003", name: "Hasnain Shabbir" },
      { rollnumber: "LHSFSCMM2056517", name: "Dua-e-Zainab Kazmi" },
      { rollnumber: "GRWFSCMM2000791", name: "Huzaifa" }
    ],
    [
      { rollnumber: "FSBFSCEM2001392", name: "Nouman Aziz Baig" },
      { rollnumber: "hlpfscmm2090027", name: "Muhammad Adil Shahzad" },
      { rollnumber: "DGKICSPM2000324", name: "M Sulaiman" },
      { rollnumber: "grwfscem2000259", name: "Muhammad Hasnaat Hafeez" },
      {
        rollnumber: "RRWPICSPM2001393",
        name: "M. Zakariyya Hashmi"
      },
      { rollnumber: "GRWFSCMM2093069", name: "Hafiz Burban  Akhtar" },
      { rollnumber: "GRWFSCEM2096088", name: "Abdul Rehman Tahir" },
      { rollnumber: "LHSFSCEM2060201", name: "Suleman" },
      { rollnumber: "Lhjfscmm2070151", name: "M Nazeefulla" }
    ]
  ];

  private getPrize(i){
    if (i==0){
        return 'Rs 100,000'
    } else if (i==1){
        return 'Rs 50,000'
    } else if (i==2){
        return 'Rs 25,000'
    }else {
        return 'Merit Certificate'
    }
  }

  private formatSuffix(i) {
    var j = i % 10,
        k = i % 100;
    if (j == 1 && k != 11) {
        return i + "st";
    }
    if (j == 2 && k != 12) {
        return i + "nd";
    }
    if (j == 3 && k != 13) {
        return i + "rd";
    }
    return i + "th";
  }

  mounted() {
    localStorage[config.firstLogin] = "true";

    if (
      localStorage[config.isPre2] &&
      localStorage[config.isPre2] !== "undefined"
    )
      this.isPre2Batch = JSON.parse(localStorage[config.isPre2]);
  }
}
